<template>
  <div class="checkbox-input">
    <div class="edit" v-if="!readOnly">      
        <!-- <div v-for="valueOpt in valueOptions" :key="valueOpt"
          class="option"
          :class="internalValue === valueOpt ? 'selected' : 'unselected'"
          @click="()=>changeInternalValue(valueOpt)"
        >
          {{ valueOpt }}
        </div> -->
        <div class="fake-checkbox-container">
          <input class="checkbox" type="checkbox" v-model="internalValue">
          <div class="fake-checkbox"></div>
        </div>
    </div>
    <span v-else class="value">{{ value?'Yes':'No' }}</span>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'

export default {
  name: 'CheckboxInput',
  mixins: [inputMixin],
  components: {},
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
.checkbox-input
  align-items: center
  display: flex
  .fake-checkbox-container
    margin-right: 10px
    position: relative
  .checkbox
    left: 50%
    margin: 0
    opacity: 0
    position: absolute
    top: 50%
    transform: translate(-50%, -50%)

    &:checked
      + .fake-checkbox
        m-icon("checkbox-checked", 16)

    &:indeterminate
      + .fake-checkbox
        m-icon("checkbox-indeterminate", 16)
  .fake-checkbox
    m-icon("checkbox", 16)

</style>